export function createHStack({ Root, }) {
    Root.displayName = 'HStack';
    return Root;
}
